/**
 * Members Handler Module
 * Randomizes member order and handles member interactions
 */

const handleMembers = () => {

  // randomize order by js
  const $members = $('.member-wrapper');

  if (!$members.length) {
      return;
  }

  const $parent = $members.parent();
  const $detachedMembers = $members.detach();
  const shuffledMembers = $detachedMembers.sort(() => 0.5 - Math.random());

  $parent.append(shuffledMembers);

  // toggle content
  const $actions = shuffledMembers.find('.js-member .member__actions');

  shuffledMembers.find('.js-member').on('click', function(event) {
      event.stopPropagation();
      $(this).toggleClass('is-active');
  });

  $actions.on('click', 'a', function(event) {
      event.stopPropagation();
  });
};

export default handleMembers;
